import React, { useState, useEffect } from "react";
import axios from "axios";
import CommonHeader from "../Common Header/CommonHeader";
import { useParams } from "react-router-dom";
import "./news.css";

const AboutNewsEvents = () => {
  const { head } = useParams();
  const [about, setAbout] = useState(null);

  useEffect(() => {
    gettingData(head);
  }, [head]);

  const gettingData = async (head) => {
    try {
      const response = await axios.get(`/newsEvents.php?id=${head}`);
      if (response?.status === 200 && response.data) {
        setAbout(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const renderContent = (content) => {
    return content
      .split("\n")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>);
  };

  // Function to extract YouTube Video ID and generate embed URL
  const getYouTubeEmbedURL = (url) => {
    const youtubePattern =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/?|\S*?[?&]v=|(?:youtube\.com\/)?(?:v|e(?:mbed)?\/))(\S{11})(?=\?|$)|youtu\.be\/(\S{11}))/;
    const match = url.match(youtubePattern);
    if (match && (match[1] || match[2])) {
      const videoId = match[1] || match[2];
      return `https://www.youtube.com/embed/${videoId}`;
    }
    return null; // Return null if the URL is not a valid YouTube link
  };

  // If data is still loading or not available, show loading message
  if (!about) {
    return (
      <>
        <h3>Loading...</h3>
      </>
    );
  }

  return (
    <>
      <CommonHeader heading={about.title.toUpperCase()} />
      <div className="container" style={{ marginTop: "2rem" }}>
        <div className="row">
          {/* First Row: Centered Image or Video */}
          <section className="col-sm-12 text-center">
            {/* Check if image exists or use video */}
            {about.images && about.images.length > 0 ? (
              <img
                src={`${axios.defaults.baseURL}/Images/${about.images[0]}`}
                alt="Event"
                className="img-fluid mb-3"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            ) : about.video_path ? (
              // Check if video exists and embed YouTube video
              getYouTubeEmbedURL(about.video_path) ? (
                <iframe
                  width="100%"
                  height="auto"
                  src={getYouTubeEmbedURL(about.video_path)}
                  frameBorder="0"
                  allowFullScreen
                  title={about.title}
                  style={{ maxWidth: "100%", height: "50rem" }}
                />
              ) : (
                <div>No valid video found</div>
              )
            ) : (
              <div>No image or video found</div>
            )}
          </section>

          {/* Second Row: Event Description and Date */}
          <section className="col-sm-12">
            <div className="mb-3">
              <p className="contentSection">
                {renderContent(about.description)}
              </p>
            </div>
            <div className="text-muted">
              <p className="date">
                Event Date: {new Date(about.event_date).toLocaleDateString()}
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default AboutNewsEvents;
